import { useAtom }                                                  from "jotai";
import { useEffect }                                                from "react";
import useSWR                                                       from "swr";
import { notificationPageCountAtom, notificationPageCountFlagAtom } from "_root/jotai/notifications";
import { getNotificationCount }                                     from "_services/api/user";
import Presentation                                                 from "./presentation";

const fetcher = async () => {
	const res = await getNotificationCount ();

	return res.count;
};

const component = () => {

	const { data: notificationCount, error: notificationError } = useSWR ( "notification-count", fetcher, { fallbackData: 0 } );
	const [ notificationPageCount, setNotificationPageCount ]   = useAtom ( notificationPageCountAtom );
	const [ notificationPageCountFlag ]                         = useAtom ( notificationPageCountFlagAtom );

	useEffect ( () => {
		if ( notificationPageCountFlag )
			return;
		setNotificationPageCount ( notificationCount );
	}, [ notificationCount ] );

	if ( notificationError ) {
		return null;
	}

	return (
		<Presentation notificationCount = { notificationPageCount } />
	);
};

export default component;